document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".variants-container");
  const productUrl = container
    ? container.getAttribute("data-product-url")
    : null;
  // console.log(productUrl);

  let quantity = 1;

  function changeQuantity(change) {
    quantity = Math.max(1, quantity + change);
    const qtyInput = document.getElementById("product-quantity");
    if (qtyInput) qtyInput.value = quantity;
  }

  const qtyDecrement = document.getElementById("product-qty-decrement");
  const qtyIncrement = document.getElementById("product-qty-increment");

  if (qtyDecrement)
    qtyDecrement.addEventListener("click", () => changeQuantity(-1));
  if (qtyIncrement)
    qtyIncrement.addEventListener("click", () => changeQuantity(1));

  const addToCartBtn = document.querySelector(".add-to-cart-btn");
  const buyNowBtn = document.querySelector(".buy-now-btn");

  function updateBtnText(btn, text) {
    if (!btn) return;
    const innerSpan = btn.querySelector(".button__inner");
    if (innerSpan) {
      innerSpan.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  // Helper to scroll gallery to variant image
  function scrollGalleryToVariantImage(featuredImage) {
    if (!featuredImage) return;
    const gallery = document.querySelector("product-gallery");
    if (gallery && typeof gallery.scrollToVariantImage === "function") {
      gallery.scrollToVariantImage(featuredImage);
    }
  }

  // Helper to ensure variant radios are checked on initial load
  function initVariantRadios() {
    if (
      typeof product === "undefined" ||
      !product ||
      !product.variants ||
      product.variants.length === 0
    ) {
      return;
    }
    const container = document.querySelector(".variants-container");
    if (!container) return;

    const allRadios = Array.from(
      container.querySelectorAll('input[type="radio"]'),
    );
    if (allRadios.length === 0) return;

    const defaultVariant =
      (product.selected_variant_id &&
        product.variants.find((v) => v.id === product.selected_variant_id)) ||
      product.selected_or_first_available_variant ||
      product.variants.find((v) => v.available) ||
      product.variants[0];

    if (!defaultVariant || !defaultVariant.options) return;

    const groupNames = [...new Set(allRadios.map((r) => r.name))];
    groupNames.forEach((groupName) => {
      const match = groupName.match(/option-(\d+)/);
      if (!match) return;
      const posIdx = parseInt(match[1], 10) - 1;
      const targetVal = defaultVariant.options[posIdx];

      const groupRadios = allRadios.filter((r) => r.name === groupName);
      const hasChecked = groupRadios.some((r) => r.checked);

      if (!hasChecked && targetVal !== undefined) {
        const matchingRadio =
          groupRadios.find((r) => r.value === targetVal) || groupRadios[0];
        if (matchingRadio) {
          matchingRadio.checked = true;
        }
      }

      // Synchronize label active states for this group
      groupRadios.forEach((r) => {
        const label = r.closest(".option") || r.closest("label");
        if (label) {
          label.classList.toggle("is-active", r.checked);
          label.classList.toggle("active", r.checked);
        }
      });
    });

    // Update color label if present
    const checkedColorRadio = container.querySelector(
      '.color-siblings-options input[type="radio"]:checked, input[type="radio"][name*="color" i]:checked, input[type="radio"][name*="colour" i]:checked',
    );
    if (checkedColorRadio && checkedColorRadio.value) {
      document.querySelectorAll(".selected-color-name").forEach((el) => {
        el.textContent = checkedColorRadio.value;
      });
    }

    updateOptionsAvailability();
    const initialMatched = getMatchedVariant();
    updateLowStockIndicator(initialMatched);
    if (initialMatched) {
      const idInput = container.querySelector('input[name="id"]');
      if (idInput) idInput.value = initialMatched.id;
    }
  }

  // Funtion to get matchedVariant
  function getMatchedVariant() {
    if (
      typeof product === "undefined" ||
      !product ||
      !product.variants ||
      product.variants.length === 0
    ) {
      return null;
    }

    const container = document.querySelector(".variants-container");
    const allRadios = container
      ? container.querySelectorAll('input[type="radio"]')
      : document.querySelectorAll('.variants-container input[type="radio"]');

    // If product has no variant option radios (single/default variant product)
    if (!allRadios || allRadios.length === 0) {
      if (container) {
        const hiddenIdInput = container.querySelector('input[name="id"]');
        if (hiddenIdInput && hiddenIdInput.value) {
          const found = product.variants.find(
            (v) => String(v.id) === String(hiddenIdInput.value),
          );
          if (found) return found;
        }
      }
      return (
        product.selected_or_first_available_variant ||
        product.variants[0] ||
        null
      );
    }

    const checkedRadios = Array.from(
      (container || document).querySelectorAll(
        'input[type="radio"]:checked',
      ),
    );

    const selectedOptionsByPosition = {};
    checkedRadios.forEach((radio) => {
      const match = radio.name.match(/option-(\d+)/);
      if (match) {
        const position = parseInt(match[1], 10);
        selectedOptionsByPosition[position] = radio.value;
      }
    });

    if (Object.keys(selectedOptionsByPosition).length === 0) {
      return (
        (product.selected_variant_id &&
          product.variants.find((v) => v.id === product.selected_variant_id)) ||
        product.selected_or_first_available_variant ||
        product.variants.find((v) => v.available) ||
        product.variants[0] ||
        null
      );
    }

    const matchedVariant = product.variants.find((variant) => {
      return Object.entries(selectedOptionsByPosition).every(([pos, val]) => {
        const idx = parseInt(pos, 10) - 1;
        return variant.options[idx] === val;
      });
    });

    return (
      matchedVariant ||
      product.selected_or_first_available_variant ||
      product.variants.find((v) => v.available) ||
      product.variants[0] ||
      null
    );
  }

  function togglePurchaseActions(isAvailable) {
    const addToCartBtn = document.querySelector(".add-to-cart-btn");
    const buyNowBtn = document.querySelector(".buy-now-btn");
    const joinWaitlistBtn = document.querySelector(".join-waitlist-btn");

    if (isAvailable) {
      if (addToCartBtn) addToCartBtn.style.display = "";
      if (buyNowBtn) buyNowBtn.style.display = "";
      if (joinWaitlistBtn) joinWaitlistBtn.style.display = "none";
    } else {
      if (addToCartBtn) addToCartBtn.style.display = "none";
      if (buyNowBtn) buyNowBtn.style.display = "none";
      if (joinWaitlistBtn) joinWaitlistBtn.style.display = "";
    }
  }

  // function to check and update option-level availability (is-disabled class & data-available)
  function updateOptionsAvailability() {
    if (typeof product === "undefined" || !product || !product.variants) return;

    const container = document.querySelector(".variants-container");
    if (!container) return;

    // Get currently selected options by position index (0-based)
    const checkedRadios = Array.from(
      container.querySelectorAll('input[type="radio"]:checked'),
    );

    const selectedByPosition = {};
    checkedRadios.forEach((radio) => {
      const match = radio.name.match(/option-(\d+)/);
      if (match) {
        const pos = parseInt(match[1], 10) - 1;
        selectedByPosition[pos] = radio.value;
      }
    });

    // Evaluate every radio input in the container
    const allRadios = Array.from(
      container.querySelectorAll('input[type="radio"]'),
    );

    allRadios.forEach((radio) => {
      const match = radio.name.match(/option-(\d+)/);
      if (!match) return;

      const currentPos = parseInt(match[1], 10) - 1;
      const val = radio.value;

      // Check if there is an available variant with this radio's value combined with other selected options
      const isAvailable = product.variants.some((variant) => {
        if (variant.options[currentPos] !== val) return false;

        const matchesOtherOptions = Object.entries(selectedByPosition).every(
          ([posStr, selectedVal]) => {
            const pos = parseInt(posStr, 10);
            if (pos === currentPos) return true;
            return variant.options[pos] === selectedVal;
          },
        );

        return matchesOtherOptions && variant.available;
      });

      radio.dataset.available = isAvailable ? "true" : "false";

      const label = radio.closest(".option") || radio.closest("label");
      if (label) {
        label.classList.toggle("is-disabled", !isAvailable);
      }
    });
  }

  // Function to update the low stock count indicator for the selected variant
  function updateLowStockIndicator(matchedVariant) {
    const indicator = document.getElementById("product-low-stock-indicator");
    if (!indicator) return;

    if (!matchedVariant) {
      indicator.classList.add("is-hidden");
      return;
    }

    // Parse inventory lookup data from the embedded script tag
    let inventoryMap = null;
    const inventoryScript = document.getElementById("product-variants-inventory");
    if (inventoryScript) {
      try {
        inventoryMap = JSON.parse(inventoryScript.textContent);
      } catch (e) {
        console.warn("Failed to parse product-variants-inventory JSON", e);
      }
    }

    const variantData = inventoryMap ? inventoryMap[String(matchedVariant.id)] : null;
    const threshold = parseInt(indicator.dataset.threshold || "5", 10);
    const messageTemplate =
      indicator.dataset.message || "Only [count] left in stock - order soon!";

    // Check inventory conditions
    const qty = variantData ? variantData.inventory_quantity : matchedVariant.inventory_quantity;
    const management = variantData
      ? variantData.inventory_management
      : matchedVariant.inventory_management;
    const isAvailable = matchedVariant.available;

    const isTracked = management && management.trim() !== "";
    const isLowStock =
      isAvailable && isTracked && typeof qty === "number" && qty > 0 && qty <= threshold;

    if (isLowStock) {
      const textSpan = indicator.querySelector(".low-stock-text");
      if (textSpan) {
        textSpan.textContent = messageTemplate.replace("[count]", String(qty));
      }
      indicator.classList.remove("is-hidden");
    } else {
      indicator.classList.add("is-hidden");
    }
  }

  // function to check availablity of product
  function checkAvailablity() {
    updateOptionsAvailability();
    const matched = getMatchedVariant();
    updateLowStockIndicator(matched);
    if (!matched) return;

    togglePurchaseActions(matched.available);

    if (!addToCartBtn) return;

    updateBtnText(addToCartBtn, matched.available ? "Add to Cart" : "sold out");
    addToCartBtn.classList.toggle("not-available", !matched.available);
    if (buyNowBtn) {
      updateBtnText(buyNowBtn, matched.available ? "Buy now" : "sold out");
      buyNowBtn.disabled = !matched.available;
      buyNowBtn.style.cursor = matched.available ? "pointer" : "not-allowed";
      buyNowBtn.style.pointerEvents = matched.available ? "auto" : "none";
      buyNowBtn.style.opacity = matched.available ? 1 : 0.5;
    }

    if (matched.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.style.cursor = "pointer";
      addToCartBtn.style.pointerEvents = "auto";
      addToCartBtn.style.opacity = 1;
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.style.cursor = "not-allowed";
      addToCartBtn.style.pointerEvents = "none";
      addToCartBtn.style.opacity = 0.5;
    }
  }

  // Funtion to update price
  function updatePrice(newPriceInCents) {
    const priceElement = document.querySelectorAll(".product-price");
    if (!priceElement) return;
    priceElement.forEach((productPrice) => {
      productPrice.textContent = newPriceInCents;
    });
  }

  // Funtion to add to cart
  async function addToCart(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    const errorElement = document.querySelector(".product-error");

    const matchedVariant = getMatchedVariant();
    if (!matchedVariant) {
      if (errorElement) {
        errorElement.style.display = "block";
        errorElement.textContent = "Please select an available option";
      }
      return;
    }

    if (!matchedVariant.available) {
      if (errorElement) {
        errorElement.style.display = "block";
        errorElement.textContent = "This item is sold out";
      }
      return;
    }

    const formData = {
      items: [
        {
          id: matchedVariant.id,
          quantity: quantity,
        },
      ],
      sections: "cart-drawer,mejimeji-header",
    };

    try {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.cursor = "progress";
        addToCartBtn.classList.add("loading");
      }
      const rootUrl = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 422) {
          if (errorElement) {
            errorElement.style.display = "block";
            errorElement.textContent = data.description || "Unable to add to cart";
          }
          if (typeof updateCartDrawer === "function") updateCartDrawer();
          if (typeof openCart === "function") openCart();
        }
        throw new Error(data.description || "Unable to add to cart");
      }
      if (typeof updateCartDrawer === "function") updateCartDrawer();
      if (
        data.sections &&
        data.sections["mejimeji-header"] &&
        typeof updateCartCount === "function"
      ) {
        updateCartCount(data.sections["mejimeji-header"]);
      }
      if (typeof openCart === "function") openCart();
    } catch (error) {
      console.error("Cart add error:", error);
      updateBtnText(addToCartBtn, "Out of Stock");
    } finally {
      updateBtnText(addToCartBtn, "Add to Cart");
      if (addToCartBtn) {
        addToCartBtn.classList.remove("loading");
        addToCartBtn.disabled = false;
        addToCartBtn.style.cursor = "pointer";
        addToCartBtn.style.pointerEvents = "auto";
        addToCartBtn.style.opacity = 1;
      }
    }
  }

  // Funtion to buy now
  async function buyNow(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    const errorElement = document.querySelector(".product-error");
    const matchedVariant = getMatchedVariant();
    if (!matchedVariant) {
      if (errorElement) {
        errorElement.style.display = "block";
        errorElement.textContent = "Please select an available option";
      }
      return;
    }

    if (!matchedVariant.available) {
      if (errorElement) {
        errorElement.style.display = "block";
        errorElement.textContent = "This item is sold out";
      }
      return;
    }

    const formData = {
      items: [
        {
          id: matchedVariant.id,
          quantity: quantity,
        },
      ],
    };

    try {
      if (buyNowBtn) {
        buyNowBtn.disabled = true;
        buyNowBtn.style.cursor = "progress";
        buyNowBtn.classList.add("loading");
      }
      const rootUrl = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }

      const checkoutUrl = `${rootUrl}checkout`.replace(/\/\/+/g, "/");
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("Buy now error:", error);
      if (buyNowBtn) {
        buyNowBtn.classList.remove("loading");
        buyNowBtn.disabled = false;
        buyNowBtn.style.cursor = "pointer";
        buyNowBtn.style.pointerEvents = "auto";
        buyNowBtn.style.opacity = 1;
        updateBtnText(buyNowBtn, "Buy now");
      }
    }
  }

  // Function on variantChange
  function onVariantChange(event) {
    // Find parent container
    const optionValueSelectors = event.target.closest(".variants-container");
    if (!optionValueSelectors) return;

    const sectionId = optionValueSelectors.dataset.sectionId;
    const errorElement = document.querySelector(".product-error");
    if (errorElement) errorElement.style.display = "none";

    // Synchronize twin radios across desktop and mobile for the changed option
    const changedRadio = event.target;
    if (changedRadio && changedRadio.name) {
      optionValueSelectors
        .querySelectorAll(`input[type="radio"][name="${changedRadio.name}"]`)
        .forEach((radio) => {
          const isMatch = radio.value === changedRadio.value;
          radio.checked = isMatch;
          const label = radio.closest(".option") || radio.closest("label");
          if (label) {
            label.classList.toggle("is-active", isMatch);
            label.classList.toggle("active", isMatch);
          }
        });

      // Update color name labels if this radio belongs to a color swatch or option
      const isColorOption =
        changedRadio.closest(".color-siblings-options") ||
        /color/i.test(changedRadio.name) ||
        /colour/i.test(changedRadio.name) ||
        document.querySelector(".selected-color-name");

      if (isColorOption) {
        document.querySelectorAll(".selected-color-name").forEach((el) => {
          el.textContent = changedRadio.value;
        });
      }
    }

    // Instantly update option-level is-disabled states based on new selection
    updateOptionsAvailability();

    // Reconcile selections (e.g. if previous size is unavailable, switch to first available)
    reconcileSelections(
      optionValueSelectors,
      changedRadio ? changedRadio.id : null,
    );
    updateOptionsAvailability();

    // Instantly check availability and toggle UI
    const matchedVariantInstant = getMatchedVariant();
    updateLowStockIndicator(matchedVariantInstant);

    if (matchedVariantInstant) {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        updatePrice(Shopify.formatMoney(matchedVariantInstant.price));
      } else if (matchedVariantInstant.price) {
        updatePrice(`$${(matchedVariantInstant.price / 100).toFixed(2)}`);
      }

      togglePurchaseActions(matchedVariantInstant.available);

      if (matchedVariantInstant.featured_image) {
        scrollGalleryToVariantImage(matchedVariantInstant.featured_image);
      }

      // Update hidden variant id input if present
      const idInput = optionValueSelectors.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = matchedVariantInstant.id;
      }

      // Update button states immediately
      if (matchedVariantInstant.available) {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.style.cursor = "pointer";
          addToCartBtn.style.pointerEvents = "auto";
          addToCartBtn.style.opacity = 1;
          updateBtnText(addToCartBtn, "Add to Cart");
        }
        if (buyNowBtn) {
          buyNowBtn.disabled = false;
          buyNowBtn.style.cursor = "pointer";
          buyNowBtn.style.pointerEvents = "auto";
          buyNowBtn.style.opacity = 1;
          updateBtnText(buyNowBtn, "Buy now");
        }
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.style.cursor = "not-allowed";
          addToCartBtn.style.pointerEvents = "none";
          addToCartBtn.style.opacity = 0.5;
          updateBtnText(addToCartBtn, "sold out");
        }
        if (buyNowBtn) {
          buyNowBtn.disabled = true;
          buyNowBtn.style.cursor = "not-allowed";
          buyNowBtn.style.pointerEvents = "none";
          buyNowBtn.style.opacity = 0.5;
          updateBtnText(buyNowBtn, "sold out");
        }
      }

      // Update URL query parameter
      const cleanUrl = window.location.href.split(/[?#]/)[0];
      window.history.replaceState(
        {},
        "",
        `${cleanUrl}?variant=${matchedVariantInstant.id}`,
      );

      // Background section fetch to keep Shopify session and analytics aligned
      if (sectionId) {
        fetch(
          `${cleanUrl}?section_id=${sectionId}&variant=${matchedVariantInstant.id}`,
        )
          .then((response) => {
            if (!response.ok) throw new Error("Section fetch failed");
            return response.text();
          })
          .then(() => {
            // Background sync complete
          })
          .catch((err) => {
            console.warn("Background section update:", err);
          });
      }
    } else {
      togglePurchaseActions(false);
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.cursor = "not-allowed";
        addToCartBtn.style.pointerEvents = "none";
        addToCartBtn.style.opacity = 0.5;
        updateBtnText(addToCartBtn, "sold out");
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = true;
        buyNowBtn.style.cursor = "not-allowed";
        buyNowBtn.style.pointerEvents = "none";
        buyNowBtn.style.opacity = 0.5;
        updateBtnText(buyNowBtn, "sold out");
      }
    }
  }

  // Use event delegation on a static parent element
  const purchaseOptionsContainer = document.querySelector(
    ".variants-container",
  );
  if (purchaseOptionsContainer) {
    purchaseOptionsContainer.addEventListener("change", (event) => {
      if (event.target.matches('input[type="radio"]')) {
        onVariantChange(event);
      }
    });

    purchaseOptionsContainer.addEventListener("click", (event) => {
      const radio = event.target.matches('input[type="radio"]')
        ? event.target
        : event.target.closest("label")
          ? event.target.closest("label").querySelector('input[type="radio"]')
          : null;
      if (radio && radio.checked) {
        const matched = getMatchedVariant();
        if (matched && matched.featured_image) {
          scrollGalleryToVariantImage(matched.featured_image);
        }
      }
    });
  }

  function updateEventListeners() {
    // console.log("Added");
    if (addToCartBtn) addToCartBtn.addEventListener("click", addToCart);
    if (buyNowBtn) buyNowBtn.addEventListener("click", buyNow);

    const joinWaitlistBtn = document.querySelector(".join-waitlist-btn");
    if (joinWaitlistBtn) {
      joinWaitlistBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const productTitle = typeof product !== 'undefined' ? product.title : null;
        document.dispatchEvent(new CustomEvent("waitlist:open", { detail: { productTitle } }));
      });
    }
  }

  function reconcileSelections(optionRootEl, changedRadioId) {
    const allRadios = Array.from(
      optionRootEl.querySelectorAll('input[type="radio"]'),
    );
    const groupNames = [...new Set(allRadios.map((radio) => radio.name))];

    let focusEl = null;

    groupNames.forEach((groupName) => {
      const groupRadios = allRadios.filter((r) => r.name === groupName);
      const checkedRadio = groupRadios.find((r) => r.checked);

      const isCurrentValid =
        checkedRadio &&
        !checkedRadio.disabled &&
        (checkedRadio.value !== "" || checkedRadio.dataset.optionValueId);

      if (!isCurrentValid) {
        // Pick first available radio (not disabled)
        const firstAvailable = groupRadios.find(
          (r) => !r.disabled && (r.value !== "" || r.dataset.optionValueId),
        );

        if (firstAvailable) {
          firstAvailable.checked = true;

          // Prefer focusing the radio the user changed; otherwise focus this one
          if (firstAvailable.id === changedRadioId) {
            focusEl = firstAvailable;
          } else if (!focusEl) {
            focusEl = firstAvailable;
          }
        }
      } else {
        // Current selection is valid; maintain focus priority on the changed radio
        if (checkedRadio.id === changedRadioId && !focusEl) {
          focusEl = checkedRadio;
        }
      }

      // Synchronize label active states for this group
      groupRadios.forEach((r) => {
        const label = r.closest(".option") || r.closest("label");
        if (label) {
          label.classList.toggle("is-active", r.checked);
          label.classList.toggle("active", r.checked);
        }
      });
    });

    // Apply focus after reconciliation
    if (focusEl) {
      focusEl.focus();
    }
  }

  initVariantRadios();
  updateEventListeners();
  checkAvailablity();
});

// function toggleDetail(header) {
//   const content = header.nextElementSibling;
//   const arrow = header.querySelector("span");
//   header.setAttribute('aria-expanded', 'true')

//   // Close all other details
//   document.querySelectorAll(".detail-content").forEach((detail) => {
//     if (detail !== content) {
//       detail.classList.remove("active");
//       detail.previousElementSibling.setAttribute('aria-expanded', 'false')
//     }
//   });

//   document.querySelectorAll(".detail-header span").forEach((span) => {
//     if (span !== arrow) {
//       span.style.transform = "rotate(0deg)";
//     }
//   });

//   // Toggle current detail
//   content.classList.toggle("active");
//   arrow.style.transform = content.classList.contains("active")
//     ? "rotate(180deg)"
//     : "rotate(0deg)";
//   header.setAttribute('aria-expanded', content.classList.contains("active") ? "true": "false");
// }
